"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVBCard = require("../../SVBCard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVBTwoCards Component
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders SVBTwoCards
 */

/**
 * SVBTwoCards Component
 * @param title1- Left card title
 * @param description1- Left card description text
 * @param title2- Right card title
 * @param description2- Right card description text 
 * @param button1Text- Button title for left card
 * @param handleButton1Press- method to handle left card button click
 * @param button2Text- Right card button text
 * @param handleButton2Press- method to handle right card button click
 * see ../readme.MD for sample body
 * @returns 
 */
const SVBTwoCards = props => {
  var _props$title, _props$title2, _props$description, _props$description2, _props$button1Text, _props$button2Text;
  const title1 = (_props$title = props === null || props === void 0 ? void 0 : props.title1) !== null && _props$title !== void 0 ? _props$title : "";
  const title2 = (_props$title2 = props === null || props === void 0 ? void 0 : props.title2) !== null && _props$title2 !== void 0 ? _props$title2 : "";
  const description1 = (_props$description = props === null || props === void 0 ? void 0 : props.description1) !== null && _props$description !== void 0 ? _props$description : "";
  const description2 = (_props$description2 = props === null || props === void 0 ? void 0 : props.description2) !== null && _props$description2 !== void 0 ? _props$description2 : "";
  const button1Text = (_props$button1Text = props === null || props === void 0 ? void 0 : props.button1Text) !== null && _props$button1Text !== void 0 ? _props$button1Text : "";
  const button2Text = (_props$button2Text = props === null || props === void 0 ? void 0 : props.button2Text) !== null && _props$button2Text !== void 0 ? _props$button2Text : "";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row py-9 card-alternative-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/_react.default.createElement(_SVBCard.SVBCard, {
    title: title1,
    description: description1,
    buttonLabel: button1Text,
    titleStyle: "card-text-color heading-medium-large font-family-roboto",
    descriptionStyle: "card-text-color font-family-roboto",
    showButton: true,
    extraClasses: "card-alternative-background border-0 shadow-none",
    handleButtonPress: props === null || props === void 0 ? void 0 : props.handleButton1Press,
    buttonStyle: "font-family-roboto"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/_react.default.createElement(_SVBCard.SVBCard, {
    title: title2,
    description: description2,
    buttonLabel: button2Text,
    titleStyle: "card-text-color heading-medium-large font-family-roboto",
    descriptionStyle: "card-text-color font-family-roboto",
    showButton: true,
    extraClasses: "card-alternative-background border-0 shadow-none",
    handleButtonPress: props === null || props === void 0 ? void 0 : props.handleButton2Press,
    buttonStyle: "font-family-roboto"
  })))));
};
var _default = SVBTwoCards;
exports.default = _default;